import 'react-toastify/dist/ReactToastify.css';
import './header.css';
import { useState, useEffect } from 'react';
import LOYALBUDS from "../../media/images/loyalbuds_dark_pro.png";
import { FaSignOutAlt, FaBars, FaTimes } from "react-icons/fa";
import TokenService from '../../services/token_services';
import BusinessService from '../../services/business_services';

//TRANSLATION
import { useTranslation } from 'react-i18next';

function Header({ page }) {
    const [merchant, setMerchant] = useState({});
    const [menuOpen, setMenuOpen] = useState(false);

    const loadMerchant = async () => {
        const data = await BusinessService.business()
        setMerchant({
            name: data.business.business_name,
            website: data.business.website,
            address: data.business.address,
            city: data.business.city,
            country: data.business.country,
            description: data.business.description,
            credits: data.business.credits,
            monthly_credits: data.business.monthly_credits,
            created_date: data.business.created_date,
            logo: data.business.logo || data.business.logo_url,
            pro: data.business,
            user: data.user
        })
    }

    useEffect(() => {
        loadMerchant();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="merchant_header">
            <img src={LOYALBUDS} className="header_logo" alt="logo LoyalBuds" />
            <div className="header_nav_desktop">
                <div className={page === "Buds" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/buds"}>
                    Buds | Cartes de fidélité
                </div>
                <div className={page === "Profile" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/profile"}>
                    Profil commerce
                </div>
                <div className={page === "Notif" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/notify"}>
                    Informez vos clients
                </div>
                <div className={page === "Credits" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/credits"}>
                    {merchant?.credits} <small style={{ fontVariant: "small-caps" }}>crédits</small>
                </div>
                <div className="header_entry header_logout_desktop" style={{ backgroundColor: "rgba(0, 0, 0, 0)" }} onClick={TokenService.removeUser}>
                    <FaSignOutAlt />
                </div>
            </div>
            <div className="header_hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <FaTimes /> : <FaBars />}
            </div>
            {menuOpen && <div className="header_nav_mobile">
                <div className={page === "Buds" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/buds"}>
                    Buds | Cartes de fidélité
                </div>
                <div className={page === "Profile" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/profile"}>
                    Profil commerce
                </div>
                <div className={page === "Notif" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/notify"}>
                    Informez vos clients
                </div>
                <div className={page === "Credits" ? "header_entry_selected" : "header_entry"} onClick={() => window.location.href = "/merchants/credits"}>
                    {merchant?.credits} <small style={{ fontVariant: "small-caps" }}>crédits</small>
                </div>
                <div className="header_entry" onClick={TokenService.removeUser}>
                    <FaSignOutAlt /> Déconnexion
                </div>
            </div>}
        </div>
    );
}

export default Header;
